import { Select, DatePicker, Input, Switch, Tabs } from 'antd'
import moment, { Moment } from 'moment'
import React, { Component, ReactNode } from 'react'
import 'react-dropdown/style.css'
import { Navigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { APP_EVENTS, DATE_FORMAT_ISO, SWITCH_FUNCTION } from '../../../../constants'
import {
  CONFIG_BOOKING_PAYMENTTERM,
  DEFAULT_BOOKING_PAYMENT_TERM,
  ONETIME_BOOKING_MANDATORY_FIELD
} from '../../../../constants/booking.config'
import { ApplicationContext } from '../../../../data'
import {
  AccountInfoDto,
  CurrentCompanyInfoInfoResponseDto,
  CustomerRole,
  NewCustomerRequestBodyDto,
  PaymentTerm,
  SuggestField,
  CategoryLevelLabel,
  CategoryLevel,
  ServiceCategoryDto,
  ServiceDto,
  ResidentialType,
  AddressType,
  CustomerAddressDto,
  EmployeeModule,
  VendorInfoDto,
  LocationProximity,
  PromoCodeUsed,
  AccountType
} from '../../../../definition'
import {
  BookingDto,
  BOOKING_TYPE,
  TaskAppointmentDto,
  UpdateTaskAppointmentDto,
  BookingStatus,
  TaskDto,
  TaskStatus,
  ServiceCategories,
  NewRecurring2BookingDto,
  RecurringFrequency
} from '../../../../definition/booking.dto'
import { MiscNoteDto, NewNoteDto, UpdateNoteDto } from '../../../../definition/notes.dto'
import { QuoteDto } from '../../../../definition/quote.dto'
import { ServiceSlotStatus, TimeSlotDurationDto, TimeSlotSession } from '../../../../definition/time-slot.dto'
import { appEventEmitter, ENV, processLoading } from '../../../../initialization'
import {
  asyncAcceptReschedule,
  asyncCreateCustomer,
  asyncGetCompanyInfor,
  asyncGetCustomerAddress,
  asyncGetCustomerDetail,
  asyncGetServiceCategories,
  asyncGetServices,
  asyncRejectReschedule
} from '../../../../services'
import {
  asyncBookingDetail,
  asyncGetTimeSlotsByDate,
  asyncUpdateTaskAppointment,
  asyncCancelBooking,
  asyncSendBooking,
  asyncGetServiceAvailability,
  asyncGetStaticData,
  asyncDeleteBooking,
  createRecurring2Booking,
  updateRecurring2Booking,
  endRecurring2Booking,
  cancelEndRecurring2Booking
} from '../../../../services/booking.service'
import { asyncCreateNote } from '../../../../services/notes.service'
import {
  asyncGetListTechnicianLocationProximity,
  asyncGetListTechnicians
} from '../../../../services/technician.service'
import { timeSlotToDate } from '../../../../utils/datetime'
import { ConfirmModalData } from '../../../components/confirm-modal.component'
import { ModalNode } from '../../../components/modal.component'
import { CustomerAutosuggest } from '../customer/customer-auto-suggestion'
import { CustomerPhoneAutosuggest } from '../customer/phone-auto-suggestion'
import { NewMiscNoteModal } from '../notes/new-misc-notes'
import {
  checkDeactiveAccount,
  employeeLabel,
  findParentCategory,
  findServiceCategory,
  getBase64FromUrl,
  isMainCategoryLabelAll,
  updateUrlParam
} from '../../../../utils'
import { BookingDetailPDF } from './new-contract-booking'
import OneTimeBookingPDF from './pdf/onetimeBookingPDF'
import jsPDF from 'jspdf'
import CustomerAddress from './booking-customer-address/customer-address'
import TextArea from 'antd/lib/input/TextArea'
import { CONFIG_COUNTRY_CODE, CONFIG_RESIDENTIAL_TYPE, EMPLOYEE_MODULE } from '../../../../constants/common.config'
import { requiredIcon } from '../../../components/requiredIcon'
import { asyncGetListVendors, asyncGetVendorAvailability } from '../../../../services/vendors.service'
import { TechnicianReport } from '../task/technician-report.component'
import { getMainCategoryByBookingType } from '../../../../utils/booking-util'
import { RangePickerProps } from 'antd/lib/date-picker'
import CancelBooking from './cancel-booking'
import SubBookings from './sub-bookings'
import { CheckOutlined, CiCircleFilled, ExclamationCircleOutlined, MinusCircleFilled } from '@ant-design/icons'
import { EndRecurringBooking } from './end-recurring-booking'

export interface NewRecurringBookingProps {}

export interface DropdownOptionProps {
  value: string
  label: string
  className?: string
}

export interface MultiSericeDto {
  serviceId?: string
  mainCategoryId?: string
  subCategoryId?: string
  childCategoryId?: string
  notes?: string
}

const defaultMultiService = {
  serviceId: undefined,
  mainCategoryId: undefined,
  subCategoryId: undefined,
  childCategoryId: undefined,
  notes: ''
}

export interface NewRecurringBookingState {
  bookingId?: string
  bookingDto?: BookingDto

  jobOrderNum?: string

  customerName?: string
  customerNameError?: boolean

  email?: string
  emailError?: boolean

  contactNumber?: string
  contactNumberError?: boolean

  contactNumberCode?: string
  contactNumberCodeError?: boolean

  address1?: string
  address1Error?: boolean

  address2?: string
  postalCode?: string
  postalCodeError?: boolean

  city?: string
  cityError?: boolean

  country?: string
  countryError?: boolean

  quote?: QuoteDto

  appointmentDate?: Date
  appointmentDateError?: boolean

  timeSlotBegin: string
  timeSlotEnd: string
  timeSlotError?: boolean
  timeSlots: TimeSlotSession[]
  taskStatus?: TaskStatus
  timeSlotBeginPrefer?: Date
  timeSlotEndPrefer?: Date
  acknowledgementTime?: Date

  serviceId?: string
  serviceTypeError?: boolean

  paymentTerm?: PaymentTerm
  paymentTermError?: boolean

  paymentTermValue?: number
  paymentTermValueError?: boolean
  chargeFeeCancelReschedule?: boolean

  selectVendor?: VendorInfoDto
  assigneeId?: string
  assigneeError?: boolean
  assignTechnicianId?: string
  assignTechnicianIdError?: boolean
  frequency?: RecurringFrequency
  frequencyError?: boolean
  recurringDay?: string
  recurringDayError?: boolean
  temporaryBlockOffEmployee?: boolean

  notes?: string
  notesError?: boolean

  residentialType?: ResidentialType
  residentialTypeError?: boolean

  fetchAssigneeId?: string

  quoteCode?: string
  customerId?: string
  promoCodeUsed?: PromoCodeUsed

  technicians: AccountInfoDto[]
  vendors?: VendorInfoDto[]
  assignOptions: DropdownOptionProps[]
  services: ServiceDto[]
  locationProximity?: LocationProximity[]

  miscNoteId?: string
  miscNote?: NewNoteDto | UpdateNoteDto
  cachedMiscNote?: any
  tasks?: TaskDto[]

  isNew: boolean
  isEdit: boolean
  loading: boolean

  status?: BookingStatus

  suggestOn?: SuggestField
  listMainCategory: ServiceCategoryDto[]
  listSubCategory: ServiceCategoryDto[]
  listChildCategory: ServiceCategoryDto[]

  mainCategoryId?: string
  mainCategoryIdError?: boolean
  subCategoryId?: string
  subCategoryIdError?: boolean
  childCategoryId?: string
  childCategoryIdError?: boolean
  serviceCategories?: ServiceCategories

  designatedAddress?: CustomerAddressDto
  billingAddress?: CustomerAddressDto
  isSameDesignatedAddress?: boolean
  subContactId?: string
  availability?: string[]
  timeSlotAvailable?: TimeSlotDurationDto[]
  serviceDuration?: number
  invoiceTerm?: string
  siteAccessIssue?: string
  pricePerSession?: number
  activeTab?: string
}

export interface DropdownOptionProps {
  value: string
  label: string
  className?: string
}

export default class NewRecurringBooking extends Component<NewRecurringBookingProps, NewRecurringBookingState> {
  static contextType = ApplicationContext
  declare context: React.ContextType<typeof ApplicationContext>

  constructor(props: NewRecurringBookingProps) {
    super(props)
    const search = window.location.search
    const params = new URLSearchParams(search)
    const bookingId = params.get('bookingId')
    const activeTab = params.get('activeTab')
    const date = new Date()

    this.state = {
      bookingId: bookingId || '',
      isNew: !bookingId,
      isEdit: bookingId ? true : false,
      timeSlots: [],
      timeSlotBegin: '',
      timeSlotEnd: '',
      contactNumberCode: undefined,
      assigneeId: undefined,
      assignTechnicianId: undefined,
      paymentTerm: PaymentTerm.FPP,
      chargeFeeCancelReschedule: true,

      appointmentDate: date,
      recurringDay: moment(date).format('dddd'),
      services: [],
      technicians: [],
      assignOptions: [],
      jobOrderNum: 'BOXXXX',
      cachedMiscNote: null,
      tasks: [],
      loading: true,
      suggestOn: SuggestField.NAME,
      listMainCategory: [],
      listSubCategory: [],
      listChildCategory: [],
      mainCategoryId: undefined,
      subCategoryId: undefined,
      childCategoryId: undefined,
      serviceId: undefined,
      isSameDesignatedAddress: false,
      temporaryBlockOffEmployee: true,
      activeTab: activeTab || 'Primary-Information'
    }
  }

  componentDidMount(): void {
    this.doInit()
    this.loadOptionData({})
  }

  componentDidUpdate(
    prevProps: Readonly<NewRecurringBookingProps>,
    prevState: Readonly<NewRecurringBookingState>,
    snapshot?: any
  ): void {
    if (this.state.mainCategoryId && this.state.appointmentDate) {
      if (
        this.state.mainCategoryId !== prevState.mainCategoryId ||
        this.state.appointmentDate !== prevState.appointmentDate
      ) {
        this.loadAvailability(this.state.mainCategoryId, moment(this.state.appointmentDate).format('M-YYYY'))
      }
    }

    if (this.state.serviceId && this.state.appointmentDate) {
      if (this.state.serviceId !== prevState.serviceId || this.state.appointmentDate !== prevState.appointmentDate) {
        this.loadSlotDuration(this.state.serviceId, moment(this.state.appointmentDate).format('YYYY-MM-DD'))
      }
    }

    if (this.state.mainCategoryId) {
      if (
        this.state.mainCategoryId !== prevState.mainCategoryId ||
        this.state.assigneeId !== prevState.assigneeId ||
        this.state.designatedAddress !== prevState.designatedAddress ||
        this.state.timeSlotBegin !== prevState.timeSlotBegin ||
        this.state.timeSlotEnd !== prevState.timeSlotEnd
      ) {
        this.loadLocationProximity()
      }
    }
  }

  validateCustomer = () => {
    let formValid = true

    if (ONETIME_BOOKING_MANDATORY_FIELD.contactNumber) {
      if (!this.state.contactNumber) {
        this.setState({ contactNumberError: true })
        formValid = false
      }
    }

    if (ONETIME_BOOKING_MANDATORY_FIELD.customerName) {
      if (!this.state.customerId && !this.state.customerName) {
        this.setState({ customerNameError: true })
        formValid = false
      }
    }

    if (ONETIME_BOOKING_MANDATORY_FIELD.email) {
      if (!SWITCH_FUNCTION.tech_cus_required_only_contact) {
        if (!this.state.email) {
          this.setState({ emailError: true })
          formValid = false
        }
      }
    }

    if (!SWITCH_FUNCTION.multi_address) {
      if (ONETIME_BOOKING_MANDATORY_FIELD.address1) {
        if (!this.state.address1) {
          this.setState({ address1Error: true })
          formValid = false
        }
      }

      if (ONETIME_BOOKING_MANDATORY_FIELD.postalCode) {
        if (!this.state.postalCode) {
          this.setState({ postalCodeError: true })
          formValid = false
        }
      }

      if (ONETIME_BOOKING_MANDATORY_FIELD.residentialType) {
        if (!this.state.residentialType) {
          this.setState({ residentialTypeError: true })
          formValid = false
        }
      }
    }

    if (ONETIME_BOOKING_MANDATORY_FIELD.contactNumberCode) {
      if (!this.state.contactNumberCode) {
        this.setState({ contactNumberCodeError: true })
        formValid = false
      }
    }

    if (this.state.paymentTerm === PaymentTerm.CREDIT && !this.state.paymentTermValue) {
      toast.error('Duration days must greater than 0')
      this.setState({ paymentTermValueError: true })
      formValid = false
    }

    return formValid
  }

  validateFields = () => {
    const validStatus: any = {}
    const bookingDto: any = {}
    let formValid = true
    let errorMsg = []

    if (!SWITCH_FUNCTION.multi_address) {
      if (ONETIME_BOOKING_MANDATORY_FIELD.address1) {
        if (!this.state.address1) {
          validStatus.address1Error = true
          formValid = false
        }
      }

      if (ONETIME_BOOKING_MANDATORY_FIELD.postalCode) {
        if (!this.state.postalCode) {
          validStatus.postalCodeError = true
          formValid = false
        }
      }

      if (ONETIME_BOOKING_MANDATORY_FIELD.postalCode) {
        if (!this.state.postalCode) {
          validStatus.postalCodeError = true
          formValid = false
        }
      }
    }

    if (!this.state.paymentTerm) {
      validStatus.paymentTermError = true
      formValid = false
      errorMsg.push(<p>Please select Payment Term</p>)
    }

    if (!this.state.appointmentDate) {
      validStatus.appointmentDateError = true
      formValid = false
    }

    if (!this.state.availability?.includes(moment(this.state.appointmentDate).format('YYYY-MM-DD'))) {
      validStatus.appointmentDateError = true
      errorMsg.push(<p>Please select another date</p>)
      formValid = false
    }
    if (!this.state.timeSlotBegin) {
      validStatus.timeSlotError = true
      formValid = false
      errorMsg.push(<p>Please select Timeslot</p>)
    }

    if (ONETIME_BOOKING_MANDATORY_FIELD.service) {
      if (!this.state.serviceId && !SWITCH_FUNCTION.multi_onetime) {
        validStatus.serviceTypeError = true
        formValid = false
      }
    }

    // if (ONETIME_BOOKING_MANDATORY_FIELD.assignId) {
    //   if (!this.state.assigneeId) {
    //     validStatus.assigneeError = true
    //     formValid = false
    //     errorMsg.push(<p>Please assign vendor</p>)
    //   }
    // }

    if (!this.state.frequency) {
      validStatus.frequencyError = true
      formValid = false
      errorMsg.push(<p>Please select Frequency</p>)
    }

    if (!this.state.recurringDay) {
      validStatus.recurringDayError = true
      formValid = false
      errorMsg.push(<p>Please select Recurring Day</p>)
    }

    if (
      this.state.paymentTerm === PaymentTerm.PPP &&
      (!this.state.paymentTermValue || this.state.paymentTermValue <= 0 || this.state.paymentTermValue >= 100)
    ) {
      formValid = false
      this.setState({ paymentTermValueError: true })
      toast.error('Partial Payment Percentage must be greater than 0 and smaller than 100')
    }

    errorMsg.length && toast.error(<>{errorMsg}</>)

    formValid &&= this.validateCustomer()

    if (SWITCH_FUNCTION.multi_address) {
      if (!this.state.designatedAddress) {
        toast.error('Must select Designated Address')
        formValid = false
      }
      if (!this.state.billingAddress) {
        toast.error('Must select Billing Address')
        formValid = false
      }
    }

    if (!formValid) {
      this.setState({
        ...validStatus
      })
      return {
        status: formValid,
        dto: undefined
      }
    }

    bookingDto.customerId = this.state.customerId || ''
    bookingDto.jobOrderNo = this.state.jobOrderNum
    bookingDto.serviceId = this.state.serviceId
    bookingDto.frequency = this.state.frequency
    bookingDto.recurringDay = this.state.recurringDay
    bookingDto.temporaryBlockOffEmployee = this.state.temporaryBlockOffEmployee || false

    if (EMPLOYEE_MODULE === EmployeeModule.Vendor) {
      bookingDto.vendors = this.state.assigneeId ? [{ id: this.state.assigneeId }] : undefined
      if (SWITCH_FUNCTION.admin_assign_tech) {
        bookingDto.assigneeId = this.state.assignTechnicianId
      }
    } else {
      bookingDto.assigneeId = this.state.assigneeId || ''
    }
    bookingDto.miscNoteId = this.state.miscNoteId || ''
    // bookingDto.type = BOOKING_TYPE.ONE_TIME
    bookingDto.notes = this.state.notes || undefined

    if (SWITCH_FUNCTION.multi_address) {
      bookingDto.address1 = this.state.designatedAddress?.addressLine1 || ''
      bookingDto.address2 = this.state.designatedAddress?.addressLine2 || ''
      bookingDto.postalCode = this.state.designatedAddress?.addressPostalCode || ''
      bookingDto.city = this.state.designatedAddress?.addressCity || ''
      bookingDto.country = this.state.designatedAddress?.addressCountry || ''
      bookingDto.residentialType = this.state.designatedAddress?.residentialType
      bookingDto.destinationAddressId = this.state.designatedAddress?.id
      bookingDto.unitNo = this.state.designatedAddress?.unitNo

      bookingDto.billingAddressLine1 = this.state.billingAddress?.addressLine1 || ''
      bookingDto.billingAddressLine2 = this.state.billingAddress?.addressLine2 || ''
      bookingDto.billingAddressPostalCode = this.state.billingAddress?.addressPostalCode || ''
      bookingDto.billingAddressCity = this.state.billingAddress?.addressCity || ''
      bookingDto.billingAddressCountry = this.state.billingAddress?.addressCountry || ''
      bookingDto.billingResidentialType = this.state.billingAddress?.residentialType
      bookingDto.billingUnitNo = this.state.billingAddress?.unitNo
      bookingDto.isSameDesignatedAddress = this.state.isSameDesignatedAddress
    } else {
      bookingDto.address1 = this.state.address1
      bookingDto.address2 = this.state.address2 || ''
      bookingDto.postalCode = this.state.postalCode
      bookingDto.city = this.state.city || ''
      bookingDto.country = this.state.country || ''
    }

    const dates = timeSlotToDate(
      this.state.appointmentDate || new Date(),
      this.state.timeSlotBegin,
      this.state.timeSlotEnd
    )

    bookingDto.timeSlotBeginAt = dates.dateStart
    bookingDto.timeSlotEndAt = dates?.dateEnd
    bookingDto.subContactId = this.state.subContactId
    bookingDto.chargeFeeCancelReschedule = !!this.state.chargeFeeCancelReschedule

    return {
      status: formValid,
      dto: bookingDto as NewRecurring2BookingDto
    }
  }

  doInit = async () => {
    await this.loadDataOnInit()
  }

  loadDataOnInit = async () => {
    this.setState({ ...this.state, loading: true })
    const services = (await asyncGetServices({ all: true }))?.items
    const timeSlots: TimeSlotSession[] =
      (this.state.appointmentDate &&
        // !this.state.bookingId &&
        (await asyncGetTimeSlotsByDate(this.state.appointmentDate)).timeSlots.filter(
          (item) => item.status !== ServiceSlotStatus.FULL
        )) ||
      []

    if (SWITCH_FUNCTION.hierachy_category) {
      let listMain = (
        await asyncGetServiceCategories({
          level: CategoryLevel.Main,
          all: true,
          includeAll: true
        })
      ).items

      const listSub = (
        await asyncGetServiceCategories({
          level: CategoryLevel.Sub
        })
      )?.items

      const listChild = (
        await asyncGetServiceCategories({
          level: CategoryLevel.Child,
          limit: 1000
        })
      )?.items

      if (SWITCH_FUNCTION.service_booking_type) {
        listMain = getMainCategoryByBookingType({
          listMain: listMain,
          listSub: listSub,
          listChild: listChild,
          listServices: services,
          bookingType: BOOKING_TYPE.RECURRING2
        })
      }

      this.setState({
        listMainCategory: listMain || [],
        listSubCategory: listSub || [],
        listChildCategory: listChild || []
      })
    }

    // Load booking detail
    if (this.state.bookingId) {
      try {
        const booking = await asyncBookingDetail(this.state.bookingId)
        if (booking) {
          const accountId = booking.accountId
          const accountDto = await asyncGetCustomerDetail(accountId)
          booking.account = accountDto

          // Update state
          const startDate = booking.bookedServices?.[0].timeSlotBeginAt
            ? moment(booking.bookedServices?.[0].timeSlotBeginAt, DATE_FORMAT_ISO).toDate()
            : undefined

          const timeSlotBegin = booking.bookedServices?.[0]?.timeSlotBeginAt
            ? moment(booking.bookedServices?.[0].timeSlotBeginAt).format('hh:mmA')
            : ''
          const timeSlotEnd = booking.bookedServices?.[0]?.timeSlotEndAt
            ? moment(booking.bookedServices?.[0].timeSlotEndAt).format('hh:mmA')
            : ''
          const timeSlotBeginPrefer = booking.tasks?.[0]?.timeSlotBeginPrefer
          const timeSlotEndPrefer = booking.tasks?.[0]?.timeSlotEndPrefer
          const acknowledgementTime = booking.tasks?.[0]?.acknowledgementTime

          const findChildIdCategory = SWITCH_FUNCTION.hierachy_category
            ? findServiceCategory(booking.bookedServices?.[0].service?.categoryId, this.state.listChildCategory)
            : undefined
          const findSubIdCategory = findChildIdCategory
            ? findParentCategory(findChildIdCategory, this.state.listSubCategory)
            : undefined
          const findMainIdCategory = findSubIdCategory
            ? findParentCategory(findSubIdCategory, this.state.listMainCategory)
            : undefined

          let contactToShow = accountDto?.profile?.contact
          let contactCodeToShow = accountDto?.profile?.countryCode

          const subContact = accountDto?.profile?.subContacts?.find((contact) => contact.id === booking.subContactId)
          if (subContact) {
            contactToShow = subContact?.contact
            contactCodeToShow = subContact?.countryCode
          }

          const assigneeId = booking.bookedServices?.[0].assignee?.company?.id

          this.setState({
            jobOrderNum: booking.code,

            customerId: accountId,
            customerName: accountDto?.profile?.name,
            contactNumber: contactToShow,
            contactNumberCode: contactCodeToShow,
            email: accountDto?.email,
            address1: booking.bookedServices?.[0].address1,
            address2: booking.bookedServices?.[0].address2,
            postalCode: booking.bookedServices?.[0].postalCode,
            city: booking.bookedServices?.[0].city,
            country: booking.bookedServices?.[0].country,

            serviceId: booking.bookedServices?.[0].service?.id,
            assigneeId: assigneeId,
            fetchAssigneeId: assigneeId,
            assignTechnicianId: booking.bookedServices?.[0].assignee?.id,

            quoteCode: booking.code,
            quote: booking.quote,

            appointmentDate: startDate,
            timeSlotBegin: timeSlotBegin,
            timeSlotEnd: timeSlotEnd,
            timeSlotBeginPrefer: timeSlotBeginPrefer,
            timeSlotEndPrefer: timeSlotEndPrefer,
            acknowledgementTime: acknowledgementTime,

            siteAccessIssue: booking.tasks?.[0]?.siteAccessIssue,

            miscNoteId: booking.miscNote?.id,
            tasks: booking.tasks,
            paymentTerm: booking.paymentTerm,
            paymentTermValue: booking.paymentTermValue,
            chargeFeeCancelReschedule: booking.chargeFeeCancelReschedule,
            notes: booking?.bookedServices?.[0].notes,

            bookingDto: booking,
            status: booking.status,
            mainCategoryId: findMainIdCategory ? findMainIdCategory.id : undefined,
            subCategoryId: findSubIdCategory ? findSubIdCategory.id : undefined,
            childCategoryId: findChildIdCategory ? findChildIdCategory.id : undefined,
            serviceCategories: booking?.bookedServices?.[0].serviceCategories,
            serviceDuration: booking?.bookedServices?.[0].service?.serviceDuration,
            promoCodeUsed: booking.promoCodeUsed,
            pricePerSession: booking?.bookedServices?.[0].service?.priceRecurring2,
            temporaryBlockOffEmployee: booking?.bookedServices?.[0]?.temporaryBlockOffEmployee || false,
            frequency: booking?.bookedServices?.[0]?.frequency,
            recurringDay: booking?.bookedServices?.[0]?.recurringDay
          })

          if (SWITCH_FUNCTION.multi_address) {
            const designatedAddress = {
              addressLine1: booking.bookedServices?.[0].address1 || '',
              addressLine2: booking.bookedServices?.[0].address2 || '',
              addressPostalCode: booking.bookedServices?.[0].postalCode || '',
              addressCity: booking.bookedServices?.[0].city || '',
              addressCountry: booking.bookedServices?.[0].country || '',
              residentialType: booking.bookedServices?.[0].residentialType || ResidentialType.Commercial,
              unitNo: booking.bookedServices?.[0].unitNo || '',
              accountId: '',
              addressName: '',
              isPrimary: false,
              id: booking.bookedServices?.[0].destinationAddressId,
              addressType: AddressType.Designated
            }
            const billingAddress = {
              addressLine1: booking.bookedServices?.[0].billingAddressLine1 || '',
              addressLine2: booking.bookedServices?.[0].billingAddressLine2 || '',
              addressPostalCode: booking.bookedServices?.[0].billingAddressPostalCode || '',
              addressCity: booking.bookedServices?.[0].billingAddressCity || '',
              addressCountry: booking.bookedServices?.[0].billingAddressCountry || '',
              residentialType: booking.bookedServices?.[0].billingResidentialType || ResidentialType.Commercial,
              unitNo: booking.bookedServices?.[0].billingUnitNo || '',
              accountId: '',
              addressName: '',
              isPrimary: false,
              id: '',
              addressType: AddressType.Billing
            }
            this.setState({
              designatedAddress: designatedAddress,
              billingAddress: booking.bookedServices?.[0].isSameDesignatedAddress ? designatedAddress : billingAddress
            })
          }

          if (findMainIdCategory) {
            this.loadOptionData({ mainCategoryId: findMainIdCategory.id })
          }
        }
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
        return
      }
    }

    this.setState({
      services: services,
      timeSlots,
      loading: false
    })
  }

  loadOptionData = async ({ mainCategoryId }: { mainCategoryId?: string }) => {
    const technicians = (await asyncGetListTechnicians({ all: true }))?.items
    const vendors = EMPLOYEE_MODULE === EmployeeModule.Vendor ? (await asyncGetListVendors({ all: true }))?.items : []

    const assignOptions: DropdownOptionProps[] = []

    if (EMPLOYEE_MODULE === EmployeeModule.Vendor) {
      if (vendors && vendors.length > 0) {
        vendors
          .filter((vendor) => {
            if (!mainCategoryId) return true
            return vendor.mainCategoryId === mainCategoryId
          })
          .forEach((assign) => {
            if (assign.status === 'active' && !this.state.bookingId) {
              assignOptions.push({
                value: assign.id,
                label: assign?.name || ''
              })
            } else {
              assignOptions.push({
                value: assign.id,
                label: `${assign?.name}${assign.status === 'active' ? '' : ' (Deactive)'}` || 'Missing name'
              })
            }
          })
      }
    }
    if (EMPLOYEE_MODULE === EmployeeModule.Technician) {
      technicians?.forEach((assign) => {
        if (assign.isActive && !this.state.bookingId) {
          assignOptions.push({
            value: assign.id,
            label: assign.profile?.name || ''
          })
        } else {
          assignOptions.push({
            value: assign.id,
            label: `${assign.profile?.name}${!assign.isActive ? ' (Deactive)' : ''}` || 'Missing name'
          })
        }
      })
    }

    const staticData = await asyncGetStaticData()

    this.setState({
      assignOptions,
      technicians: technicians || [],
      vendors: vendors,
      invoiceTerm: staticData.invoice_term
    })
  }

  loadLocationProximity = async () => {
    const datePart = moment(this.state.appointmentDate).format('YYYY-MM-DD')
    const startTime = `${datePart} ${this.state.timeSlotBegin}`
    const endTime = `${datePart} ${this.state.timeSlotEnd}`
    const locationProximities = await asyncGetListTechnicianLocationProximity({
      destinationAddressId: this.state.designatedAddress?.id,
      timeSlotBeginAt: this.state.timeSlotBegin ? moment(startTime, 'YYYY-MM-DD hh:mmA').utc().format() : undefined,
      timeSlotEndAt: this.state.timeSlotEnd ? moment(endTime, 'YYYY-MM-DD hh:mmA').utc().format() : undefined,
      // vendorId: this.state.assigneeId,
      mainCategoryId: this.state.mainCategoryId,
      // taskId: this.state.tasks?.[0]?.id,
      assigneeId: this.state.assignTechnicianId
    })
    this.setState({ locationProximity: locationProximities })
  }

  loadAvailability = async (mainCategoryId: string, monthYear: string) => {
    const availability = await asyncGetVendorAvailability(mainCategoryId, monthYear)
    this.setState({
      availability: availability
    })
  }

  loadSlotDuration = async (serviceId: string, date: string) => {
    const slotAvailable = await asyncGetServiceAvailability(serviceId, date)
    this.setState({
      timeSlotAvailable: slotAvailable
    })
  }

  redirectToSchedule() {
    window.document.location = '/schedule'
  }

  createCustomer = async (next?: () => void) => {
    if (!this.validateCustomer()) {
      return
    }

    const customerDto: NewCustomerRequestBodyDto = {
      contact: this.state.contactNumber || '',
      countryCode: this.state.contactNumberCode || undefined,
      email: this.state.email || undefined,
      password: 'Abc@123456',
      name: this.state.customerName || '',
      customerRole: CustomerRole.INDIVIDUAL,
      paymentTerm: PaymentTerm.COD,
      designatedAddressLine1: this.state.address1,
      designatedAddressLine2: this.state.address2,
      designatedAddressPostalCode: this.state.postalCode,
      designatedAddressCity: this.state.city,
      designatedAddressCountry: this.state.country
    }

    const doCreate = async () => {
      const account = await asyncCreateCustomer(customerDto)
      if (account) {
        this.setState(
          {
            customerId: account.id
          },
          () => {
            toast.success(<>The customer was created!</>)
            if (next) {
              next()
            }
          }
        )
      }
    }

    try {
      await processLoading(doCreate())
    } catch (error: any) {
      const errMsg = error.response?.data?.error?.message || error.message
      console.error(errMsg)
      toast.error(<>{errMsg}</>)
    }
  }

  doCreateBooking = async (dto: NewRecurring2BookingDto) => {
    let newMiscNote: MiscNoteDto | undefined
    if (this.state.miscNote && !this.state.cachedMiscNote) {
      try {
        newMiscNote = await asyncCreateNote(this.state.miscNote)
        this.setState({
          ...this.state,
          cachedMiscNote: newMiscNote
        })
        dto.miscNoteId = newMiscNote?.id
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }
    if (this.state.cachedMiscNote) {
      dto.miscNoteId = this.state.cachedMiscNote.id
    }
    dto.chargeFeeCancelReschedule = !!this.state.chargeFeeCancelReschedule
    dto.paymentTerm = this.state.paymentTerm
    dto.paymentTermValue = this.state.paymentTermValue
    // only one miscnote is created, so if create booking failed bcz miss field, then we need to cached the misc that created before
    await processLoading(createRecurring2Booking(dto))
  }

  handleCancelScheduledEnd = async () => {
    const { bookingDto } = this.state
    if (!bookingDto?.id) return

    appEventEmitter.emit(APP_EVENTS.app_confirm_modal, {
      title: 'Are you sure you want to cancel the scheduled end for this booking?',
      onOK: async () => {
        try {
          await processLoading(cancelEndRecurring2Booking(bookingDto.id))
          toast.success('Successfully canceled scheduled end')
          await this.doInit()
        } catch (error: any) {
          const errMsg = error.response?.data?.error?.message || error.message
          console.error(errMsg)
          toast.error(errMsg)
        }
      }
    } as ConfirmModalData)
  }

  onCreateBooking = () => {
    if (!this.validateCustomer()) {
      appEventEmitter.emit<ConfirmModalData>(APP_EVENTS.app_confirm_modal, {
        title: <>Please enter the customer’s info and service details before saving</>,
        hideOK: true,
        cancelText: 'Close'
      })
      return
    }
    if (!this.state.customerId) {
      appEventEmitter.emit<ConfirmModalData>(APP_EVENTS.app_confirm_modal, {
        title: (
          <>
            We need a customer first.
            <br />
            Do you want to create this customer?
          </>
        ),
        onOK: () => this.createCustomer(this.onCreateBooking)
      })
      return
    }

    const { status, dto } = this.validateFields()
    if (!status) {
      return
    }

    this.doCreateBooking(dto)
      .then((_) => {
        toast.success(<>One time booking for [{dto.jobOrderNo}] was created!</>)
        this.redirectToSchedule()
      })
      .catch((error) => {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      })
  }

  onBookingSave = async () => {
    if (!this.state.bookingId) {
      toast.error(<>Something wrong with this booking data, please check its data!</>)
      return
    }

    if (checkDeactiveAccount(this.state.technicians, this.state.assigneeId)) {
      toast.error(<>Please assign a new {employeeLabel()}!</>)
      this.setState({
        assigneeError: true
      })
      return
    }

    const { status, dto } = this.validateFields()
    if (!status) {
      return
    }

    const doUpdate = async () => {
      try {
        await updateRecurring2Booking(this.state.bookingId!, dto)
        toast.success(<>The booking has been updated!</>)
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }

    await processLoading(doUpdate())
  }

  onConfirmCancel() {
    appEventEmitter.emit<ConfirmModalData>(APP_EVENTS.app_confirm_modal, {
      title: 'Are you sure you want to end this booking?',
      description: `Once ended it cannot be undone.`,
      onOK: async () => {
        if (this.state.bookingId) {
          try {
            await processLoading(endRecurring2Booking(this.state.bookingId))
            toast.success('Success cancel booking')
            // this.redirectToSchedule()
            this.doInit()
          } catch (error: any) {
            const errMsg = error.response?.data?.error?.message || error.message
            console.error(errMsg)
            toast.error(<>{errMsg}</>)
          }
        }
      },
      onCancel: () => {}
    })
  }

  handleDeleteBooking(bookingId: string) {
    const processDelete = async () => {
      await asyncDeleteBooking(bookingId)
    }

    appEventEmitter.emit<ConfirmModalData>(APP_EVENTS.app_confirm_modal, {
      title: (
        <>
          Are you sure you want to delete Booking No. {this.state.bookingDto?.code}?
          <br />
          Once deleted it cannot be undone.
        </>
      ),
      onOK: () =>
        processLoading(
          processDelete()
            .then(() => {
              toast.success('Delete')
              this.redirectToSchedule()
            })
            .catch((error) => {
              let errorMessage =
                error?.response?.status >= 500 ? (
                  <>
                    Can not process the deletion!.
                    <br />
                    Maybe service have the related data, so we can not delete it.
                    <br />
                    Please contact with admin developer for get more detail!
                  </>
                ) : (
                  error.response?.data?.error?.message || error.message
                )
              toast.error(errorMessage)
            })
        )
    })
  }

  onAddMiscNote = () => {
    appEventEmitter.emit<ModalNode>(APP_EVENTS.app_modal, {
      input: {
        onSave: (miscNote: NewNoteDto) => {
          this.setState({ miscNote })
        },
        bookingId: this.state.bookingId,
        noteId: null,
        miscNote: null,
        editable: true,
        configuration: this.context?.contextData?.authenticationData?.configuration || {}
      },
      status: true,
      node: NewMiscNoteModal,
      title: `Add Employee Note`,
      onClose: () => {},
      onDone: (miscNote) => {
        this.addNotesIfHaveBooking(miscNote)
        toast.success('Employee Note Added')
        // if (this.state.bookingId) {
        //   this.onBookingSave()
        // }
      }
    })
  }

  async addNotesIfHaveBooking(miscNote: NewNoteDto) {
    if (!this.state.bookingId || !this.state.bookingDto?.tasks || !this.state.bookingDto?.tasks.length) {
      toast.success(<>Something wrong with this booking data, please check its data!</>)
      return
    }

    if (!this.state.assigneeId) {
      this.setState({
        assigneeError: true
      })
      return
    }

    const taskAppointments: TaskAppointmentDto[] = this.state.bookingDto?.tasks.map((task) => {
      const dates = timeSlotToDate(
        this.state.appointmentDate || new Date(),
        this.state.timeSlotBegin,
        this.state.timeSlotEnd
      )
      return {
        taskId: task.id,
        timeSlotBeginAt: dates?.dateStart || task.timeSlotBeginAt,
        timeSlotEndAt: dates?.dateEnd || task.timeSlotEndAt,
        assigneeId: this.state.assigneeId
      }
    })

    const updateTaskDto: UpdateTaskAppointmentDto = {
      bookingId: this.state.bookingId,
      appointments: taskAppointments
    }

    let newMiscNote: MiscNoteDto | undefined
    if (!this.state.miscNoteId && !this.state.cachedMiscNote) {
      try {
        newMiscNote = await asyncCreateNote(miscNote)
        this.setState({
          ...this.state,
          cachedMiscNote: newMiscNote,
          miscNoteId: newMiscNote?.id
        })
        updateTaskDto.miscNoteId = newMiscNote?.id
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }
    if (this.state.miscNoteId) {
      updateTaskDto.miscNoteId = this.state.miscNoteId
    }

    const doUpdate = async () => {
      try {
        await asyncUpdateTaskAppointment(updateTaskDto)
        toast.success(<>The booking has been updated!</>)
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }

    await processLoading(doUpdate())
  }

  onUpdateMiscNote = () => {
    appEventEmitter.emit<ModalNode>(APP_EVENTS.app_modal, {
      input: {
        onSave: (miscNote: UpdateNoteDto) => {
          this.setState({ miscNote })
        },

        noteId: this.state.miscNoteId,
        miscNote: this.state.miscNote,
        editable: true,
        configuration: this.context?.contextData?.authenticationData?.configuration || {}
      },
      status: true,
      node: NewMiscNoteModal,
      title: `Update Empployee Note`,
      onClose: () => {},
      onDone: () => {}
    })
  }

  onViewMiscNote = () => {
    appEventEmitter.emit<ModalNode>(APP_EVENTS.app_modal, {
      input: {
        onSave: (miscNote: UpdateNoteDto) => {
          this.setState({ miscNote })
        },

        noteId: this.state.miscNoteId,
        miscNote: this.state.miscNote,
        editable: false,
        configuration: this.context?.contextData?.authenticationData?.configuration || {}
      },
      status: true,
      node: NewMiscNoteModal,
      title: `View ${employeeLabel({ isFirstLetterUp: true })} Note`,
      onClose: () => {},
      onDone: () => {}
    })
  }

  onCustomerSuggestionSelected = async (customer: AccountInfoDto) => {
    let defaultDesign = undefined
    let defaulBilling = undefined
    if (SWITCH_FUNCTION.multi_address) {
      defaultDesign = await this.getDefaultAddress(customer.id, AddressType.Designated)
      defaulBilling = await this.getDefaultAddress(customer.id, AddressType.Billing)
    }

    let contactNumberCountryCode = customer.profile?.countryCode
    if (customer.subContactId) {
      contactNumberCountryCode = customer.profile?.subContacts?.[0].countryCode
    }

    this.setState({
      customerId: customer.id,

      customerName: customer.profile?.name,
      email: customer.email,

      contactNumber: customer.profile?.contact,
      contactNumberError: !customer.profile?.contact,

      contactNumberCode: contactNumberCountryCode,

      address1: customer.profileExtraCustomer?.designatedAddressLine1,
      address1Error: !customer.profileExtraCustomer?.designatedAddressLine1,

      address2: customer.profileExtraCustomer?.designatedAddressLine2,

      postalCode: customer.profileExtraCustomer?.designatedAddressPostalCode,
      postalCodeError: !customer.profileExtraCustomer?.designatedAddressPostalCode,

      city: customer.profileExtraCustomer?.designatedAddressCity,
      cityError: !customer.profileExtraCustomer?.designatedAddressCity,

      country: customer.profileExtraCustomer?.designatedAddressCountry,
      countryError: !customer.profileExtraCustomer?.designatedAddressCountry,

      // paymentTerm: customer.profileExtraCustomer?.paymentTerm,
      // paymentTermError: !customer.profileExtraCustomer?.paymentTerm,

      paymentTermValue: customer.profileExtraCustomer?.paymentTermValue,
      paymentTermValueError: !customer.profileExtraCustomer?.paymentTermValue,

      residentialType: customer.profileExtraCustomer?.designatedResidentialType,
      residentialTypeError: !customer.profileExtraCustomer?.designatedResidentialType,

      customerNameError: false,
      designatedAddress: defaultDesign,
      billingAddress: defaulBilling,
      isSameDesignatedAddress: customer.profileExtraCustomer?.isSameDesignatedAddress,
      subContactId: customer.subContactId
    })

    if (!SWITCH_FUNCTION.tech_cus_required_only_contact) {
      this.setState({
        emailError: !customer.email
      })
    }
  }

  onCustomerNameInputChange = (newValue: string) => {
    this.setState({
      customerId: undefined,
      customerName: newValue,
      customerNameError: false
    })
  }

  onCustomerPhoneInputChange = (newValue: string) => {
    this.setState({
      customerId: undefined,
      contactNumber: newValue,
      contactNumberError: false
    })
  }

  async onChangeDate(selectedDate: Moment | null) {
    if (selectedDate) {
      const timeSlots = (await processLoading(asyncGetTimeSlotsByDate(selectedDate?.toDate()))).timeSlots.filter(
        (item) => item.status !== ServiceSlotStatus.FULL
      )

      if (timeSlots.length === 0) {
        toast.warning('The date is not exist available slot!')
        return
      }
      this.setState({
        appointmentDate: selectedDate.toDate(),
        appointmentDateError: false,
        timeSlots,
        timeSlotBegin: '',
        timeSlotEnd: '',
        recurringDay: selectedDate.format('dddd')
      })
    }
  }

  allTasksCompleted(tasks: any) {
    if (tasks.length === 0) {
      return false
    }
    return tasks.filter((task: any) => task.status === 'DONE').length === tasks.length
  }

  renderTechnicianNote() {
    if (
      (!this.state.miscNoteId || this.state.isNew) &&
      !this.state.miscNote &&
      !this.allTasksCompleted(this.state.tasks)
    ) {
      return (
        <button type='button' className='secondary' onClick={() => this.onAddMiscNote()}>
          Add Employee Notes
        </button>
      )
    } else if ((this.state.miscNoteId && !this.allTasksCompleted(this.state.tasks)) || this.state.miscNote) {
      return (
        <button type='button' className='secondary' onClick={this.onUpdateMiscNote}>
          Update Employee Notes
        </button>
      )
    } else {
      return (
        <button type='button' className='secondary' onClick={this.onViewMiscNote}>
          View Employee Notes
        </button>
      )
    }
  }

  printPDF = async (sent?: boolean) => {
    setTimeout(async () => {
      const modalSection = document.querySelector('.onetime-booking-detail-pdf')
      const pdf = new jsPDF('p', 'mm', 'a4')
      pdf.html(modalSection as HTMLElement, {
        callback: (doc) => {
          if (!sent) {
            pdf.save(`Booking Details-${this.state.bookingDto?.code}.pdf`)
          } else {
            const file = doc.output('dataurlstring')
            if (this.state.bookingId) {
              asyncSendBooking(this.state.bookingId, file)
                .then(() => {
                  toast.success('Success send booking details')
                })
                .catch(() => {
                  toast.error('Fail to sent quote detail, try later')
                })
            }
          }
        },
        x: 0,
        y: 0,
        width: 210,
        windowWidth: 1440
      })
    }, 1000)
  }

  onViewPDF(sent?: boolean) {
    asyncGetCompanyInfor()
      .then(async (companyInfo: CurrentCompanyInfoInfoResponseDto) => {
        const logoBase64 = await getBase64FromUrl(companyInfo.logo)
        return { ...companyInfo, logo: logoBase64 }
      })
      .then((companyInfor) => {
        appEventEmitter.emit<ModalNode<BookingDetailPDF>>(APP_EVENTS.app_modal, {
          input: {
            companyInfo: companyInfor as CurrentCompanyInfoInfoResponseDto,
            booking: this.state.bookingDto,
            customerName: this.state.customerName,
            customerEmail: this.state.email,
            paymentTerm: this.state.paymentTerm,
            paymentTermValue: this.state.paymentTermValue,
            customerContactNumber: this.state.contactNumber,
            services: this.state.quote?.quoteToServices,
            bookedServices: this.state.bookingDto?.bookedServices,
            tasks: this.state.tasks,
            bookingDto: this.state.bookingDto,
            assignOptions: this.state.assignOptions as DropdownOptionProps[],
            notes: this.state.notes
          },
          status: true,
          node: OneTimeBookingPDF,
          title: this.state.bookingDto?.code,
          onClose: () => {}
        })
      })
      .then(() => {
        if (!sent) {
          this.printPDF()
        } else {
          this.printPDF(true)
        }
      })
  }

  printInvoicePDF = async () => {
    setTimeout(async () => {
      let modalSection
      if (SWITCH_FUNCTION.pdf_ver2) {
        modalSection = document.querySelector('.invoice-detail-pdf-ver2')
      } else {
        modalSection = document.querySelector('.invoice-detail-pdf')
      }
      const pdf = new jsPDF('p', 'mm', 'a4')
      pdf.html(modalSection as HTMLElement, {
        callback: (doc) => {
          pdf.save(`${this.state.bookingDto?.invoice?.code}.pdf`)
        },
        x: 0,
        y: 0,
        width: 210,
        windowWidth: 1440
      })
    }, 1000)
  }

  onViewInvoicePDF() {
    window.open(
      `${ENV.BACKEND_PREFIX_URL}/api/booking/invoice/download/${this.state.bookingDto?.invoice?.id}`,
      '_blank'
    )
  }

  focusSuggestion(field: SuggestField, callBack: (field: SuggestField) => void) {
    this.setState({ suggestOn: field })
    setTimeout(() => {
      callBack(field)
    }, 50)
  }

  getFocus(field: SuggestField) {
    let input
    const suggestPhoneDiv = document.querySelector('.phone-detail-number')
    const suggestNameDiv = document.querySelector('.customer-detail-name')
    if (field === SuggestField.PHONE) {
      input = suggestPhoneDiv?.querySelector('input')
    } else {
      input = suggestNameDiv?.querySelector('input')
    }
    input?.focus()
  }

  filterOption = (input: string, option?: { label?: string; value?: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  renderRequiredIcon = (condition: boolean) => {
    return condition ? <span className='input-require'>*</span> : null
  }

  setSelectAddress = (address: CustomerAddressDto, addressType: AddressType) => {
    const state = { ...this.state }
    if (addressType === AddressType.Designated) {
      state.designatedAddress = address
    } else if (addressType === AddressType.Billing) {
      state.billingAddress = address
    }

    this.setState(state)
  }

  getDefaultAddress = async (accountId: string, addressType: AddressType) => {
    const data = await asyncGetCustomerAddress({ limit: 20, offset: 0 }, addressType, accountId)
    const defaultAddress = (data?.items || []).find((add) => add.isPrimary)
    return defaultAddress
  }

  regetDefaultAddress = async (accountId: string, addressType: AddressType) => {
    const defaultAddress = await this.getDefaultAddress(accountId, addressType)
    if (addressType === AddressType.Designated) {
      this.setState({ designatedAddress: defaultAddress })
    } else if (addressType === AddressType.Billing) {
      this.setState({ billingAddress: defaultAddress })
    }
  }

  toggleBillingSameAsDesign = async () => {
    if (!this.state.isSameDesignatedAddress) {
      this.setState({ billingAddress: this.state.designatedAddress })
    } else {
      const defaultAddress = await this.getDefaultAddress(this.state.customerId as string, AddressType.Billing)
      this.setState({ billingAddress: defaultAddress })
    }
    this.setState({ isSameDesignatedAddress: !this.state.isSameDesignatedAddress })
  }

  onViewReport = () => {
    const task = this.state.tasks?.[0]
    if (!task) return
    appEventEmitter.emit<ModalNode<TaskDto>>(APP_EVENTS.app_modal, {
      input: {
        ...task,
        images: task.images?.map((image: any) => image.url),
        account: this.state.bookingDto?.account,
        booking: this.state.bookingDto
      },
      status: true,
      node: TechnicianReport,
      title: `Job Completion Report`
    })
  }

  onAcceptReschedule = (taskId?: string) => {
    if (taskId) {
      processLoading(
        asyncAcceptReschedule({
          taskId,
          timeSlotBeginAt: this.state.tasks?.[0].timeSlotBeginAtReschedule!,
          timeSlotEndAt: this.state.tasks?.[0].timeSlotEndAtReschedule!
        })
      )
        .then(() => {
          toast.success('Reschedule!')
          this.doInit()
        })
        .catch((error) => {
          const errMsg = error.response?.data?.error?.message || error.message
          console.error(errMsg)
          toast.error(<>{errMsg}</>)
        })
    }
  }

  onRejectReschedule = (taskId?: string) => {
    if (taskId) {
      processLoading(asyncRejectReschedule(taskId))
        .then(() => {
          toast.success('Reject!')
          this.doInit()
        })
        .catch((error) => {
          const errMsg = error.response?.data?.error?.message || error.message
          console.error(errMsg)
          toast.error(<>{errMsg}</>)
        })
    }
  }

  render(): ReactNode {
    if (this.state.bookingDto?.type === BOOKING_TYPE.RECURRING) {
      return <Navigate to={`/schedule/contract-booking?bookingId=${this.state.bookingId}`} />
    }
    const timeSlots = this.state.timeSlots
    const isTaskReject = this.state.tasks?.[0] && this.state.tasks?.[0].status === TaskStatus.REASSIGN
    const rejectTechName = this.state.tasks?.[0] && this.state.tasks?.[0].rejectedBy?.profile.name

    const isServiceDone = this.state.serviceCategories
    // only done then have serviceCategories;

    const disabledDate: RangePickerProps['disabledDate'] = (current) => {
      // Can not select days before today and today

      return (
        current &&
        current < moment(this.state.appointmentDate).startOf('month') &&
        current > moment(this.state.appointmentDate).endOf('month') &&
        (this.state.availability || [])?.includes(moment(current).endOf('day').format('YYYY-MM-DD')) === false
      )
    }

    const bookingDetail = (
      <div className='new-one-time-booking-body'>
        <form>
          <div className='wrapper'>
            <label className='wrapper-name'>Customer Information</label>
            <div className='row'>
              <div className='label-input' onClick={() => this.focusSuggestion(SuggestField.NAME, this.getFocus)}>
                <label>Customer Name {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.customerName)}</label>
                {this.state.isNew && this.state.suggestOn === SuggestField.NAME ? (
                  <div className={this.state.customerNameError ? 'input-error' : 'customer-detail-name'}>
                    <CustomerAutosuggest
                      onSuggestionSelected={this.onCustomerSuggestionSelected}
                      onInputChange={this.onCustomerNameInputChange}
                      value={this.state.customerName}
                    />
                  </div>
                ) : (
                  <Input
                    value={this.state.customerName}
                    disabled={this.state.isEdit}
                    placeholder='Type customer name'
                  />
                )}
              </div>
              {this.state.customerId && (
                <>
                  <div className='label-input'>
                    <label>Contact Number {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.contactNumber)}</label>
                    <div className='phone-detail'>
                      {SWITCH_FUNCTION.country_code && (
                        <Select
                          className={`${this.state.contactNumberCodeError ? 'input-error' : ''} phone-detail-code`}
                          value={this.state.contactNumberCode}
                          onChange={(value) =>
                            this.setState({
                              contactNumberCode: value,
                              contactNumberCodeError: false
                            })
                          }
                          disabled={this.state.isEdit}
                          placeholder='Select'
                          options={Object.entries(CONFIG_COUNTRY_CODE)
                            .filter(([_, config]) => config.show)
                            .map(([_, config]) => {
                              return {
                                value: config.label,
                                label: config.label
                              }
                            })}
                          showSearch
                          filterOption={this.filterOption}
                        />
                      )}
                      <div
                        onClick={() => this.focusSuggestion(SuggestField.PHONE, this.getFocus)}
                        className={`${this.state.contactNumberError ? 'input-error' : ''} phone-detail-number`}
                      >
                        {this.state.isNew && this.state.suggestOn === SuggestField.PHONE ? (
                          <div>
                            <CustomerPhoneAutosuggest
                              onSuggestionSelected={this.onCustomerSuggestionSelected}
                              onInputChange={this.onCustomerPhoneInputChange}
                              value={this.state.contactNumber}
                            />
                          </div>
                        ) : (
                          <Input
                            value={this.state.contactNumber || ''}
                            onChange={(e) => {
                              this.setState({
                                contactNumber: e.target.value,
                                contactNumberError: !e.target.value
                              })
                            }}
                            disabled={this.state.isEdit}
                            placeholder='Type customer phone'
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='label-input'>
                    <label>Email {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.email)}</label>
                    <Input
                      value={this.state.email || ''}
                      className={this.state.emailError ? 'input-error' : undefined}
                      onChange={(e) => {
                        this.setState({
                          email: e.target.value,
                          emailError: !e.target.value
                        })
                      }}
                      disabled={this.state.isEdit}
                    />
                  </div>
                  <div className='label-input'>
                    <label>Payment Terms {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.paymentTerm)}</label>
                    <Select
                      value={this.state.paymentTerm}
                      className={this.state.paymentTermError ? 'input-error' : undefined}
                      onChange={(value) => {
                        this.setState({
                          ...this.state,
                          paymentTerm: value,
                          paymentTermValue: 0,
                          paymentTermError: false
                        })
                      }}
                      options={Object.entries(CONFIG_BOOKING_PAYMENTTERM)
                        .filter(([_, config]) => config.show)
                        .map(([key, config]) => {
                          return { value: key, label: config.label }
                        })}
                      disabled={true}
                      placeholder='Select'
                    />
                  </div>
                  <div className='label-input'>
                    <label>Charge fee cancel & reschedule</label>
                    <div style={{ minHeight: 40, display: 'flex', alignItems: 'center' }}>
                      <Switch
                        checked={!!this.state.chargeFeeCancelReschedule}
                        onChange={(checked) => {
                          this.setState({
                            chargeFeeCancelReschedule: checked
                          })
                        }}
                        disabled={this.state.bookingDto?.status === BookingStatus.ENDED}
                      />
                    </div>
                  </div>
                  {this.state.paymentTerm === PaymentTerm.CREDIT && (
                    <div className='label-input'>
                      <label>Duration (Days) </label>
                      <Input
                        value={this.state.paymentTermValue}
                        className={this.state.paymentTermValueError ? 'input-error' : undefined}
                        onChange={(event) => {
                          this.setState({
                            ...this.state,
                            paymentTermValue: Number(event.target.value),
                            paymentTermValueError: false
                          })
                        }}
                        disabled={this.state.fetchAssigneeId ? true : false}
                        placeholder={''}
                        type='number'
                        min={0}
                      />
                    </div>
                  )}
                  {this.state.paymentTerm === PaymentTerm.PPP && (
                    <div className='label-input'>
                      <label>Partial Payment Percentage (%) </label>
                      <Input
                        type='number'
                        value={this.state.paymentTermValue}
                        className={this.state.paymentTermValueError ? 'input-error' : undefined}
                        onChange={(event) => {
                          this.setState({
                            ...this.state,
                            paymentTermValue: Number(event.target.value),
                            paymentTermValueError: false
                          })
                        }}
                        placeholder={''}
                        disabled={this.state.fetchAssigneeId ? true : false}
                      />
                    </div>
                  )}
                  {this.state.bookingId && (
                    <div className='label-input'>
                      <label>Created At </label>
                      <Input value={moment(this.state.bookingDto?.createdAt).format('DD MMMM YYYY, hha')} disabled />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {this.state.customerId && (
            <>
              {SWITCH_FUNCTION.multi_address && this.state.customerId && (
                <div className='wrapper'>
                  <label className='wrapper-name'>Addresses</label>
                  <div className='row row-of-2'>
                    <CustomerAddress
                      addressType={AddressType.Designated}
                      accountId={this.state.customerId}
                      bookingAddress={this.state.designatedAddress}
                      setSelectAddress={this.setSelectAddress}
                      isEditable={this.state.bookingId ? false : true}
                      regetDefaultAddress={this.regetDefaultAddress}
                    />
                    <CustomerAddress
                      addressType={AddressType.Billing}
                      accountId={this.state.customerId}
                      bookingAddress={
                        this.state.isSameDesignatedAddress ? this.state.designatedAddress : this.state.billingAddress
                      }
                      setSelectAddress={this.setSelectAddress}
                      isEditable={this.state.bookingId ? false : true}
                      regetDefaultAddress={this.regetDefaultAddress}
                      isBillingSameAsDesign={this.state.isSameDesignatedAddress}
                      toggleBillingSameAsDesign={this.toggleBillingSameAsDesign}
                    />
                  </div>
                </div>
              )}
              {!SWITCH_FUNCTION.multi_address && (
                <div className='wrapper'>
                  <label className='wrapper-name'>Addresses</label>
                  <div className='row'>
                    <div className='label-input'>
                      <label>Address (Line 1) {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.address1)}</label>
                      <input
                        value={this.state.address1 || ''}
                        className={this.state.address1Error ? 'input-error' : undefined}
                        onChange={(e) => {
                          this.setState({
                            address1: e.target.value,
                            address1Error: !e.target.value
                          })
                        }}
                        disabled={this.state.isEdit}
                      />
                    </div>
                    <div className='label-input'>
                      <label>Address (Line 2) {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.address2)}</label>
                      <input
                        value={this.state.address2 || ''}
                        onChange={(e) => {
                          this.setState({
                            address2: e.target.value
                          })
                        }}
                        disabled={this.state.isEdit}
                      />
                    </div>
                    <div className='label-input'>
                      <label>Postal Code {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.postalCode)}</label>
                      <input
                        value={this.state.postalCode || ''}
                        className={this.state.postalCodeError ? 'input-error' : undefined}
                        onChange={(e) => {
                          this.setState({
                            postalCode: e.target.value,
                            postalCodeError: !e.target.value
                          })
                        }}
                        disabled={this.state.isEdit}
                      />
                    </div>
                    <div className='label-input'>
                      <label>City {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.city)}</label>
                      <input
                        value={this.state.city || ''}
                        onChange={(e) => {
                          this.setState({
                            city: e.target.value,
                            cityError: !e.target.value
                          })
                        }}
                        disabled={this.state.isEdit}
                      />
                    </div>
                    <div className='label-input'>
                      <label>Country {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.country)}</label>
                      <input
                        value={this.state.country || ''}
                        onChange={(e) => {
                          this.setState({
                            country: e.target.value,
                            countryError: !e.target.value
                          })
                        }}
                        disabled={this.state.isEdit}
                      />
                    </div>
                    {SWITCH_FUNCTION.residential_type && (
                      <div className='label-input'>
                        <label>Residential Type {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.residentialType)}</label>
                        <select
                          value={this.state.residentialType}
                          className={`${this.state.residentialTypeError ? 'input-error' : ''}`}
                          onChange={(event) => {
                            this.setState({
                              ...this.state,
                              residentialType: event.target.value as ResidentialType,
                              residentialTypeError: !event.target.value
                            })
                          }}
                        >
                          <option value=''>Select Residential Type</option>
                          {Object.entries(CONFIG_RESIDENTIAL_TYPE)
                            .filter(([_, resi]) => resi.show)
                            .map(([key, residential]) => {
                              return <option value={key}>{residential.label}</option>
                            })}
                        </select>
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className='wrapper'>
                <label className='wrapper-name'>Primary Service Details</label>
                <div className='row'>
                  {SWITCH_FUNCTION.hierachy_category && (
                    <>
                      <div className='label-input'>
                        <label>
                          {CategoryLevelLabel.Main} {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.service)}
                        </label>
                        <Select
                          className={this.state.mainCategoryIdError ? 'input-error' : undefined}
                          value={isServiceDone ? this.state.serviceCategories?.main.id : this.state.mainCategoryId}
                          onChange={(value) => {
                            this.loadOptionData({ mainCategoryId: value })
                            this.setState({
                              mainCategoryId: value,
                              mainCategoryIdError: false,
                              subCategoryId: undefined,
                              childCategoryId: undefined,
                              serviceId: undefined,
                              assignTechnicianId: undefined,
                              assigneeId: undefined
                            })
                          }}
                          allowClear
                          showSearch
                          filterOption={this.filterOption}
                          placeholder={`Select ${CategoryLevelLabel.Main}`}
                          disabled={this.state.isEdit}
                          options={
                            !isServiceDone
                              ? this.state.listMainCategory
                                  .filter((category) => !isMainCategoryLabelAll(category))
                                  .map((category) => {
                                    return { value: category.id, label: category.name }
                                  })
                              : [
                                  {
                                    value: this.state.serviceCategories?.main.id,
                                    label: this.state.serviceCategories?.main.name
                                  }
                                ]
                          }
                        />
                      </div>
                      <div className='label-input'>
                        <label>
                          {CategoryLevelLabel.Sub} {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.service)}
                        </label>
                        <Select
                          className={this.state.subCategoryIdError ? 'input-error' : undefined}
                          value={isServiceDone ? this.state.serviceCategories?.sub.id : this.state.subCategoryId}
                          onChange={(value) => {
                            this.setState({
                              subCategoryId: value,
                              subCategoryIdError: false,
                              childCategoryId: undefined,
                              serviceId: undefined
                            })
                          }}
                          allowClear
                          showSearch
                          filterOption={this.filterOption}
                          placeholder={`Select ${CategoryLevelLabel.Sub}`}
                          disabled={this.state.isEdit}
                          options={
                            !isServiceDone
                              ? this.state.listSubCategory
                                  .filter((cat) => cat.parentId === this.state.mainCategoryId)
                                  .map((category) => {
                                    return { value: category.id, label: category.name }
                                  })
                              : [
                                  {
                                    value: this.state.serviceCategories?.sub.id,
                                    label: this.state.serviceCategories?.sub.name
                                  }
                                ]
                          }
                        />
                      </div>
                      <div className='label-input'>
                        <label>
                          {CategoryLevelLabel.Child} {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.service)}
                        </label>
                        <Select
                          className={this.state.childCategoryIdError ? 'input-error' : undefined}
                          value={isServiceDone ? this.state.serviceCategories?.child.id : this.state.childCategoryId}
                          onChange={(value) => {
                            this.setState({
                              childCategoryId: value,
                              childCategoryIdError: false,
                              serviceId: undefined
                            })
                          }}
                          allowClear
                          showSearch
                          filterOption={this.filterOption}
                          placeholder={`Select ${CategoryLevelLabel.Child}`}
                          disabled={this.state.isEdit}
                          options={
                            !isServiceDone
                              ? this.state.listChildCategory
                                  .filter((cat) => cat.parentId === this.state.subCategoryId)
                                  .map((category) => {
                                    return { value: category.id, label: category.name }
                                  })
                              : [
                                  {
                                    value: this.state.serviceCategories?.child.id,
                                    label: this.state.serviceCategories?.child.name
                                  }
                                ]
                          }
                        />
                      </div>
                    </>
                  )}
                  <div className='label-input'>
                    <label>Service Name {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.service)}</label>
                    <Select
                      className={`${this.state.serviceTypeError ? 'input-error' : undefined}`}
                      value={this.state.serviceId}
                      onChange={(value) => {
                        const findService = this.state.services.find((service) => service.id === value)
                        this.setState({
                          serviceId: value,
                          serviceTypeError: false,
                          serviceDuration: findService?.serviceDuration,
                          pricePerSession: findService?.priceRecurring2
                        })
                      }}
                      options={this.state.services
                        .filter((service) => {
                          if (this.state.bookingId) return true
                          if (SWITCH_FUNCTION.service_booking_type) {
                            return service.bookingType === BOOKING_TYPE.RECURRING2
                          } else return true
                        })
                        .filter((service: ServiceDto) => {
                          if (this.state.bookingId) return true
                          if (!SWITCH_FUNCTION.hierachy_category) {
                            return true
                          } else {
                            return service.category.id === this.state.childCategoryId
                          }
                        })
                        .map((service: ServiceDto) => {
                          return { label: service.name, value: service.id }
                        })}
                      placeholder='Select Service'
                      allowClear
                      showSearch
                      filterOption={this.filterOption}
                      disabled={this.state.isEdit}
                    />
                  </div>
                  {this.state.serviceId && (
                    <>
                      <div className='label-input'>
                        <label>Duration Per Session</label>
                        <Input
                          className={`${this.state.serviceTypeError ? 'input-error' : undefined}`}
                          value={`${this.state.serviceDuration} Hours`}
                          placeholder='Select Duration'
                          disabled={true}
                        />
                      </div>
                      <div className='label-input'>
                        <label>Price Per Session</label>
                        <Input
                          className={`${this.state.serviceTypeError ? 'input-error' : undefined}`}
                          value={`$${this.state.pricePerSession}`}
                          placeholder='Select Duration'
                          disabled={true}
                        />
                      </div>
                      <div className='label-input'>
                        <label>Frequency {requiredIcon(true)}</label>
                        <Select
                          className={`${this.state.frequencyError ? 'input-error' : undefined}`}
                          value={this.state.frequency}
                          placeholder='Select Frequency'
                          options={[
                            { value: RecurringFrequency.Weekly, label: 'Weekly' },
                            { value: RecurringFrequency.BiWeekly, label: 'BiWeekly' }
                          ]}
                          onChange={(value) => {
                            this.setState({ frequency: value })
                          }}
                          disabled={this.state.bookingDto?.status === BookingStatus.ENDED}
                        />
                      </div>
                      <div className='label-input'>
                        <label>Start Date {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.appoinmentDate)}</label>
                        <DatePicker
                          className={`date-time-picker ${this.state.appointmentDateError ? 'input-error' : ''}`}
                          value={moment(this.state.appointmentDate)}
                          disabledDate={disabledDate}
                          format='DD/MM/YYYY'
                          onChange={this.onChangeDate.bind(this)}
                          disabled={this.state.bookingDto?.status === BookingStatus.ENDED}
                        />
                      </div>
                      <div className='label-input'>
                        <label>Recurring Day {requiredIcon(true)}</label>
                        <Select
                          className={`${this.state.recurringDayError ? 'input-error' : undefined}`}
                          value={this.state.recurringDay}
                          placeholder='Select Recurring Day'
                          options={[
                            {
                              value: 'Monday',
                              label: 'Monday'
                            },
                            {
                              value: 'Tuesday',
                              label: 'Tuesday'
                            },
                            {
                              value: 'Wednesday',
                              label: 'Wednesday'
                            },
                            {
                              value: 'Thursday',
                              label: 'Thursday'
                            },
                            {
                              value: 'Friday',
                              label: 'Friday'
                            },
                            {
                              value: 'Saturday',
                              label: 'Saturday'
                            },
                            {
                              value: 'Sunday',
                              label: 'Sunday'
                            }
                          ]}
                          onChange={(value) => {
                            this.setState({ recurringDay: value })
                          }}
                          disabled={this.state.isNew}
                        />
                      </div>
                      <div className='label-input'>
                        <label>Recurring Time Slot {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.timeslot)}</label>
                        <Select
                          value={
                            this.state.timeSlotBegin
                              ? `${this.state.timeSlotBegin} - ${this.state.timeSlotEnd}`
                              : undefined
                          }
                          className={`${this.state.timeSlotError ? 'input-error' : ''}`}
                          onSelect={(selectedTimeSlot: string) => {
                            const temps = selectedTimeSlot.split(' - ')
                            this.setState({
                              timeSlotError: false,
                              timeSlotBegin: temps[0],
                              timeSlotEnd: temps[1]
                            })
                          }}
                          options={(this.state.timeSlotAvailable || []).map((item) => ({
                            label: `${moment(item.begin, 'hh:mmA').format('HH:mm')} - ${moment(
                              item.end,
                              'hh:mmA'
                            ).format('HH:mm')}`,
                            value: `${item.begin} - ${item.end}`
                          }))}
                          placeholder='Select Time Slot'
                          disabled={this.state.bookingDto?.status === BookingStatus.ENDED}
                        />
                      </div>
                      <div className='label-input'>
                        <label> Assign Primary Employee</label>
                        <Select
                          className={`${this.state.assignTechnicianIdError ? 'input-error' : undefined}
                      ${isTaskReject ? 'reassign-needed' : undefined}
                      `}
                          options={this.state.locationProximity?.map((tech) => {
                            return {
                              value: tech.id,
                              label: tech.label
                            }
                          })}
                          value={this.state.assignTechnicianId}
                          onChange={(value: any) => {
                            const findEmployee = this.state.technicians.find((emp) => emp.id === value)
                            const vendorId = this.state.assignOptions?.find(
                              (option) => option.value === findEmployee?.companyId
                            )?.value
                            this.setState({
                              assignTechnicianId: value,
                              assignTechnicianIdError: false,
                              assigneeId: vendorId
                            })
                          }}
                          placeholder={`Select a Employee`}
                          allowClear={!this.state.fetchAssigneeId}
                          showSearch
                          filterOption={this.filterOption}
                          disabled={this.state.bookingDto?.status === BookingStatus.ENDED}
                        />
                      </div>
                      <div
                        className='label-input'
                        style={{
                          opacity: this.state.assignTechnicianId ? 100 : 0
                        }}
                      >
                        <label>
                          Assign {employeeLabel({ isFirstLetterUp: true })}{' '}
                          {requiredIcon(ONETIME_BOOKING_MANDATORY_FIELD.assignId)}
                        </label>
                        <Select
                          className={`${this.state.assigneeError ? 'input-error' : undefined}
                      ${isTaskReject ? 'reassign-needed' : undefined}
                      `}
                          options={this.state.assignOptions}
                          value={this.state.assigneeId}
                          onChange={(value: any) => {
                            this.setState({
                              assigneeId: value,
                              assigneeError: false,
                              assignTechnicianId: undefined
                            })
                          }}
                          placeholder={`Select A ${employeeLabel({ isFirstLetterUp: true })}`}
                          allowClear={!this.state.fetchAssigneeId}
                          showSearch
                          filterOption={this.filterOption}
                          disabled
                        />
                      </div>
                      <div>
                        <label style={{ marginRight: 8 }}>Temporary Block Off Employee Schedule for Next 1 Year?</label>
                        <Switch
                          onChange={(check) => {
                            this.setState({ temporaryBlockOffEmployee: check })
                          }}
                          checked={this.state.temporaryBlockOffEmployee}
                          disabled={this.state.bookingDto?.status === BookingStatus.ENDED}
                        />
                      </div>
                      {SWITCH_FUNCTION.onetime_notes && (
                        <div className='label-input' style={{ gridColumn: '1 / span 3' }}>
                          <label>Additional Notes</label>
                          <TextArea
                            rows={8}
                            value={this.state.notes || ''}
                            className={this.state.notesError ? 'input-error' : undefined}
                            onChange={(e) => {
                              this.setState({
                                notes: e.target.value
                              })
                            }}
                            placeholder='Remark filled by customer. Can also be edited by Admin.'
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </form>
        <div className='onetime-action'>
          <div className='action-button action-button--left'>
            {/* {this.state.bookingDto?.id && (
              <button
                className='secondary'
                onClick={() => {
                  if (this.state.bookingDto?.id) {
                    this.handleDeleteBooking(this.state.bookingDto?.id)
                  }
                }}
              >
                Delete Permanently
              </button>
            )} */}
            {this.state.bookingDto?.id && this.state.bookingDto?.status !== BookingStatus.CANCELED && (
              <>
                {this.state.bookingDto.status !== BookingStatus.ENDED && !this.state?.bookingDto?.scheduledToEnd && (
                  <EndRecurringBooking
                    trigger={<button className='secondary'>End Recurring Booking</button>}
                    bookingId={this.state.bookingId!}
                    onSave={() => {
                      this.doInit()
                    }}
                  />
                )}
                {this.state?.bookingDto?.scheduledToEnd && (
                  <button
                    className='secondary'
                    onClick={this.handleCancelScheduledEnd}
                  >
                    Cancel Scheduled End
                  </button>
                )}
              </>
            )}
          </div>
          <div className='action-button action-button--right'>
            {this.state.isNew && (
              <button
                className='primary'
                onClick={this.onCreateBooking}
                disabled={
                  !this.state.serviceId ||
                  !this.state.recurringDay ||
                  !this.state.frequency ||
                  !this.state.timeSlotBegin
                }
              >
                Create Booking
              </button>
            )}
            {this.state.bookingDto?.id && this.state.bookingDto.status !== BookingStatus.ENDED && (
              <button className='primary' onClick={this.onBookingSave}>
                Save
              </button>
            )}
          </div>
        </div>
      </div>
    )

    const items = [
      {
        key: 'Primary-Information',
        label: 'Primary Information',
        children: <>{bookingDetail}</>
      },
      {
        key: 'List-of-Sessions',
        label: 'List of Sessions',
        children: <SubBookings bookingId={this.state.bookingId!} />
      }
    ]

    return (
      <div className={`site-page ${this.state.status === BookingStatus.CANCELED ? 'cancel' : ''}`}>
        <div className='site-page-header'>
          {this.state.isNew ? (
            <span>Create New Booking</span>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              Booking Detail
              {this.state.bookingDto ? ` (${this.state.bookingDto.code})` : ''}
              {this.state.bookingDto?.status === BookingStatus.ACTIVE && (
                <div className='booking-active-badge'>
                  <CheckOutlined /> Active
                </div>
              )}
              {this.state.bookingDto?.status === BookingStatus.ENDED && (
                <div className='booking-ended-badge'>
                  <MinusCircleFilled /> Ended
                </div>
              )}
              {this.state.bookingDto?.status === BookingStatus.PAUSE && (
                <div className='booking-ended-badge'>
                  <CiCircleFilled /> Paused
                </div>
              )}
              {this.state?.bookingDto?.scheduledToEnd && <div className='end-booking-date'><ExclamationCircleOutlined /> Scheduled to End-{moment(this.state?.bookingDto?.scheduledToEnd).format('DD/MM/YYYY')}</div>}
            </div>
          )}
        </div>
        <div className='booking-wrapper'>
          {this.state.isNew ? (
            <>{bookingDetail}</>
          ) : (
            <div className='side-page-tabs'>
              <Tabs
                defaultActiveKey={this.state.activeTab}
                items={items}
                onChange={(value) => {
                  this.setState({ activeTab: value })
                  updateUrlParam({ add: { activeTab: value } })
                }}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}
